import React, { useState } from "react";
import Input from "../../components/Input";
import Label from "../../components/Label";
import Button from "../../components/Button";
import { Link } from "react-router-dom";

// import { EyeIcon, EyeOffIcon } from "@heroicons/react/outline";
import { Formik } from "formik";
// import * as Yup from "yup";
// import Alert from "../../components/Alert";
// import useStore from "../../store";
// import { useRouter } from "next/router";
// import useRedirectIfAuthenticated from "../../hooks/useRedirectIfAuthenticated";
// import { postLogin } from "../../api/login";
// import { syncToken } from "../../api/axios";
import Cookies from "js-cookie";

// const LoginSchema = Yup.object().shape({
//   username: Yup.string().required("Nama pengguna wajib diisi"),
//   password: Yup.string().required("Kata sandi wajib diisi"),
// });

function LoginPage() {
  //   useRedirectIfAuthenticated();s
  let [showPass, setShowPass] = useState(false);
  //   let setIsAuthenticated = useStore((state) => state.setIsAuthenticated);
  //   let [errorMessage, setErrorMessage] = useState(null);

  //   let router = useRouter();
  //   async function onSubmit(values, actions, captchaToken) {
  //     try {
  //       let response = await postLogin(values);

  //       console.log(response);
  //       response = response.data.data;

  //       Cookies.set("X-Authorization", response["X-Authorization"]);
  //       Cookies.set("X-Yakes-Authorization", response["X-Yakes-Authorization"]);
  //       Cookies.set("is_authenticated", true);
  //       Cookies.set("username", response["username"]);

  //       console.log("login : ", response.data);
  //       localStorage.setItem(
  //         "roles",
  //         JSON.stringify(response?.user_details[0]?.roles)
  //       );
  //       syncToken();
  //       setIsAuthenticated(true);
  //       router.push("/");
  //     } catch (error) {
  //       console.log("error", error);
  //       if (error.response?.data?.message) {
  //         setErrorMessage(error.response?.data?.message);
  //       } else {
  //         setErrorMessage(error.message);
  //       }
  //       actions.setSubmitting(false);
  //     }
  //   }

  return (
    <div className="min-h-screen flex">
      <div className="md:w-1/2 hidden md:block  bg-gradient-to-r from-green-400 to-blue-500 has-bg-img">
        <img
          className="bg-img"
          style={{ height: "100vh", width: "100%", objectFit: "cover" }}
          src="/assets/background.png"
        />
      </div>
      <div className="md:w-1/2 w-full  bg-white  flex flex-col items-center px-10 md:px-32 py-10">
        <div className="w-full  h-full flex justify-center flex-col">
          <div className="flex flex-row">
            <div className="mr-6">
              <img src="/assets/icon/logo.svg" width="180" />
            </div>
            <div className="flex items-center">
              <img src="/assets/icon/logo_desc.svg" width="200" />
            </div>
          </div>

          {/* <div className="text-4xl font-semibold text-gray-800">AMS</div> */}
          {/* <div className="mt-2">
            <span className="text-gray-400 font-semibold">New Here?</span>{" "}
            <span className="text-lightBlue-500 font-semibold">
              Create an Account
            </span>
          </div> */}

          <Formik
            initialValues={{ username: "", password: "" }}
            // validationSchema={LoginSchema}
            onSubmit={null}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <form onSubmit={handleSubmit}>
                <div className="mt-14 space-y-5">
                  {/* <div>{"error" && <Alert>{errorMessage}</Alert>}</div> */}
                  <div>
                    <Label htmlFor="username">Nama Pengguna</Label>
                    <Input
                      name="username"
                      disabled={isSubmitting}
                      error={errors.username && touched.username}
                      id="username"
                      type="text"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.username}
                      placeholder="Nama Pengguna"
                      tabIndex="1"
                      variant="filled"
                      size="lg"
                    ></Input>
                    {errors.username && touched.username && (
                      <span className="text-red-500 text-sm mt-1">
                        {errors.username}
                      </span>
                    )}
                  </div>
                  <div>
                    <div className="flex justify-between">
                      <Label htmlFor="password">Kata Sandi</Label>
                      <span className="text-lightBlue-500 text-base">
                        Lupa Kata Sandi ?
                      </span>
                    </div>

                    <Input
                      name="password"
                      tabIndex="2"
                      disabled={isSubmitting}
                      error={errors.password && touched.password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.password}
                      variant="filled"
                      placeholder="Kata Sandi"
                      //   rightIcon={
                      //     showPass ? (
                      //       <EyeOffIcon
                      //         onClick={() => setShowPass(false)}
                      //         className="text-gray-500 cursor-pointer"
                      //       ></EyeOffIcon>
                      //     ) : (
                      //       <EyeIcon
                      //         onClick={() => setShowPass(true)}
                      //         className="text-gray-500 cursor-pointer"
                      //       ></EyeIcon>
                      //     )
                      //   }
                      type={showPass ? "text" : "password"}
                      size="lg"
                    ></Input>
                    {errors.password && touched.password && (
                      <span className="text-red-500 text-sm mt-1">
                        {errors.password}
                      </span>
                    )}
                  </div>
                </div>
                <div className="mt-12 space-y-6">
                  <Link to="/banner">
                    <Button
                      tabIndex="3"
                      htmlType="submit"
                      disabled={isSubmitting}
                      block
                      variant="solid"
                      color="blue"
                      size="lg"
                      loading={isSubmitting}
                      loadingText="Loading..."
                      style={{ padding: "10px 0px 10px 0px" }}
                    >
                      <span className="font-semibold">Masuk</span>
                    </Button>
                  </Link>
                </div>
              </form>
            )}
          </Formik>
        </div>
        <div className="py-10">2021© Yayasan Kesehatan Pertamina</div>
      </div>
    </div>
  );
}

export default LoginPage;
